import { Slide, useScrollTrigger } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react'


type Props = {
  scrollTarget: Node | undefined;
  children: React.ReactNode;

  OnChanged?: (IsSlideIn: boolean) => void;
}

/**
 * ref: https://stackoverflow.com/questions/56551045/what-is-the-usage-of-material-ui-usescrolltrigger-with-child-target-ref
 * please keep it undefined here to not make useScrollTrigger throw an error on first render 
 * 
 * ~~~js
 * // 用法
 * const [scrollTarget, setScrollTarget] = useState(undefined);
 * 
 * ...
 * 
 *  <Box style={linear_content_style} ref={node => {
 *    if (node) { // 綁定要偵測捲動的 div ref
 *       setScrollTarget(node as any);
 *    }
 *   }}>
 * ...
 * 
 * <HideOnScroll scrollTarget={scrollTarget}>
 * ... 要折疊的部分
 * </HideOnScroll>
 * ~~~
 * 
 */
const HideOnScroll = ({ scrollTarget, children, OnChanged }: Props) => {

  /** 從哪個Y軸座標(threshold)開始，偵測捲動 true=向下/false=向上 */
  const scrollTrigger = useScrollTrigger({ target: scrollTarget, threshold: 0 });

  /* 決定上方是否空間是否隱藏 */
  const [HideChildren, setHideChildren] = useState(false);
  const [HideChildrenDelayTimer, set_HideChildrenDelayTimer] = useState<NodeJS.Timeout>();

  /* 決定 SlideIn 展開/關閉 */
  const [IsSlideIn, set_IsSlideIn] = useState(false);
  const [IsSlideInDelayTimer, set_IsSlideInDelayTimer] = useState<NodeJS.Timeout>();

  /* 記憶最後一次摺疊時間點(間隔太短則強制展開，防止不斷閃爍) */
  const [LastHideAt, set_LastHideAt] = useState<moment.Moment>(moment('1800-01-01'));

  useEffect(() => {
    /* 捲動過程中中止前一個動作 */
    clearTimeout(HideChildrenDelayTimer);
    clearTimeout(IsSlideInDelayTimer);

    let hide = scrollTrigger;// 原則上 展開/關閉 是由捲動方向決定的

    if (scrollTrigger) {// 嘗試觸發隱藏時
      let sec = moment().diff(LastHideAt, 'millisecond');
      if (sec <= 2000) {
        hide = false;// 間隔太短暫，先令隱藏失效(防止不斷抖動)
        // return;
      } else {
        set_LastHideAt(moment());// 記憶間隔時間
      }
    }

    // Delay後執行顯示或隱藏背景空白區域
    set_HideChildrenDelayTimer(setTimeout(async () => {// delay open;
      setHideChildren(hide);
    }, hide ? 450 : 450));// 開啟/關閉 配合 Slide動畫稍加延遲

    // Delay後執行顯示或隱藏Slide
    set_IsSlideInDelayTimer(setTimeout(async () => {// delay open;
      set_IsSlideIn(!hide);
    }, hide ? 450 : 450));// 開啟/關閉 配合 Slide動畫稍加延遲

    //  // Delay後執行顯示或隱藏背景空白區域
    //  set_HideChildrenDelayTimer(setTimeout(async () => {// delay open;
    //   setHideChildren(hide);
    // }, hide ? 500 : 450));// 開啟/關閉 配合 Slide動畫稍加延遲

    // // Delay後執行顯示或隱藏Slide
    // set_IsSlideInDelayTimer(setTimeout(async () => {// delay open;
    //   set_IsSlideIn(!hide);
    // }, hide ? 350 : 500));// 開啟/關閉 配合 Slide動畫稍加延遲


  }, [scrollTrigger]);

  return (
    <Slide appear={false} direction="down" in={IsSlideIn}
      onEnter={(node: HTMLElement, isAppearing: boolean) => {
        OnChanged?.(IsSlideIn);
      }}

      onExited={(node: HTMLElement) => {
        OnChanged?.(IsSlideIn);
      }}
    >
      {children == null ? <></> : HideChildren ?
        <div ></div>
        :
        children as any
      }
    </Slide >
  );
}

// function HideOnScroll(scrollTarget: any, children: any) {
//   const scrollTrigger = useScrollTrigger({ target: scrollTarget });

//   // const triggerX = useScrollTrigger({ target: (contentRef.current as any) });
//   console.log("triggerX", scrollTrigger);
//   return (
//     <Slide appear={false} direction="down" in={!scrollTrigger}>
//       {children == null ? <></> : children}
//     </Slide>
//   );
// }

export default HideOnScroll